import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7ProductSummary } from "@/api/dtos";
import type { ProductSummary } from "./_models/Product";
import { toProductSummaryFromCin7ProductSummary } from "./_transformers/toProductSummaryFromCin7ProductSummary";

type ProductListResponse = Cin7ListResponse<"Products", Cin7ProductSummary>;

const PAGE_LIMIT = 500;

/** Cin7 products, first page (via the backend Cin7 proxy). */
export const getProductListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductList: builder.query<ProductSummary[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<ProductListResponse>(
            `${backendBase()}/cin7/product-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const products = res.data.Products.map((x) => toProductSummaryFromCin7ProductSummary(x));
          return { data: products };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getProductList = getProductListApi.endpoints.getProductList;
